import axios from 'axios';

// ======================== Configuration ========================
const BASE_URL = 'https://loyalty.bom.asia';

const apiClient = axios.create({
  baseURL: BASE_URL,
  headers: { 'Content-Type': 'application/json' },
});

// Interceptors
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('authToken');
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// ======================== MiniGame RVOPV Functions ========================

/**
 * Lấy tất cả MiniGame RVOPV
 */
export const fetchLoadingMiniGameRVOPV = async () => {
  try {
    const response = await apiClient.get('/api/minigameRV-OPV/all');
    return response.data || [];
  } catch (error) {
    console.error('Error fetching minigame:', error);
    throw error.response?.data || { message: 'Failed to fetch minigame' };
  }
};

/**
 * Thêm MiniGame RVOPV mới
 */
export const fetchAddMiniGameRVOPV = async (data) => {
  try {
    const response = await apiClient.post('/api/minigameRV-OPV/create', data);
    return response.data;
  } catch (error) {
    console.error('Error adding minigame:', error);
    throw error.response?.data || { message: 'Failed to add minigame' };
  }
};

/**
 * Xóa MiniGame RVOPV
 */
export const fetchDeleteMiniGameRVOPV = async (id) => {
  try {
    const response = await apiClient.delete(`/api/minigameRV-OPV/delete/${id}`);
    return { id, ...response.data };
  } catch (error) {
    console.error('Error deleting minigame:', error);
    throw error.response?.data || { message: 'Failed to delete minigame' };
  }
};

/**
 * Sửa MiniGame RVOPV
 */
export const fetchEditMiniGameRVOPV = async (id, formData) => {
  try {
    const response = await apiClient.put(`/api/minigameRV-OPV/update/${id}`, formData);
    return response.data;
  } catch (error) {
    console.error('Error updating minigame:', error);
    throw error.response?.data || { message: 'Failed to update minigame' };
  }
};

/**
 * Toggle Status MiniGame RVOPV
 */
export const fetchToggleStatusMiniGameRVOPV = async (id) => {
  try {
    const response = await apiClient.put(`/api/minigameRV-OPV/${id}/toggle-status`);
    return { id, ...response.data };
  } catch (error) {
    console.error('Error toggling minigame status:', error);
    throw error.response?.data || { message: 'Failed to toggle status' };
  }
};

// ======================== Default Export ========================
export default {
  fetchLoadingMiniGameRVOPV,
  fetchAddMiniGameRVOPV,
  fetchDeleteMiniGameRVOPV,
  fetchEditMiniGameRVOPV,
  fetchToggleStatusMiniGameRVOPV,
};

